import { render } from "./PhoneVerifyCodePopup.vue?vue&type=template&id=266b60f0"
import script from "./PhoneVerifyCodePopup.vue?vue&type=script&lang=js"
export * from "./PhoneVerifyCodePopup.vue?vue&type=script&lang=js"

import "./PhoneVerifyCodePopup.vue?vue&type=style&index=0&id=266b60f0&lang=less"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__